export default "__VITE_ASSET__CumSY1yb__"